<template>
  <div class="flex flex-col h-100">
    <div class="hidden land:flex land:items-center">
      <div><avatar :user="album.user" /></div>
      <h1 class="ml-4">{{album.name}}</h1>
      <div class="buttoncontainer m-4 p-4">
        <div v-if="user && user.id === album.userId"><router-link :to="albumPages(album)" class="button">Organize Pages</router-link></div>
        <div v-if="fullscreenEnabled"><button @click="toggleFullScreen">Toggle full screen</button></div>
        <div>
          <button @click="toggleFinderView">Toggle Finder view</button>
        </div>
        <div>
          <button @click="toggleShowMagnifyingGlass">
            <!-- Known bug: The font-awesome library I'm using doesn't know about Vue, so it switches the icon to an SVG and that DOM element will never be updated so this doesn't actually change the icons. To get around, use key. -->
            <span key="fa-search-minus" v-if="showMagnifyingGlass"><i class="fas fa-search-minus"></i> Don't Magnify</span>
            <span key="fa-search-plus" v-else><i class="fas fa-search-plus"></i> Magnify</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="showFinderView">
      <finder-view
        :pages="pages"
        :currentPageIndex="currentPageIndex"
        :onClickItem="setCurrentPageIndex"
      />
    </div>
    <div v-else>
      <album-thumbnails
        :pages="pages"
        :pagesPerSpread="album.pagesPerSpread"
        :currentPageIndex="currentPageIndex"
        :onClickItem="setCurrentPageIndex"
        :itemType="album.pagesPerSpread === 2 ? 'spread' : 'page'"
        :show-on-mobile="false"
      />
      <page-turner
        :pages="pages"
        :pagesPerSpread="album.pagesPerSpread"
        :currentPageIndex="currentPageIndex"
        :setCurrentPageIndex="setCurrentPageIndex"
        :showMagnifyingGlass="showMagnifyingGlass"
      />
    </div>
  </div>
</template>

<script>
import fscreen from 'fscreen'
import { albumPages } from '../utils/routing'
import { orderPages } from '../utils'
import { viewPage } from '../utils/routing'
import AlbumThumbnails from './AlbumThumbnails'
import FinderView from './FinderView'
import Avatar from './Avatar'
import PageTurner from './PageTurner'

const localStorageKey = 'scrapbook-share.view-album.showFinderView'

export default {
  props: ['album', 'user'],
  data() {
    let currentPageIndex = 0
    if (this.$route.params.pageId) {
      const pageId = parseInt(this.$route.params.pageId, 10)
      const pageIndex = orderPages(this.album.pages, this.album.pageOrders).findIndex(x => x.id === pageId)
      if (pageIndex >= 0) {
        currentPageIndex = pageIndex
      }
    }

    return {
      fullscreenEnabled: fscreen.fullscreenEnabled,
      currentPageIndex,
      showMagnifyingGlass: false,
      showFinderView: this.$localStorage.get(localStorageKey, false, Boolean),
    }
  },
  mounted() {
    // If page id from route is not part of this album, go to first page
    if (this.$route.params.pageId) {
      const pageId = parseInt(this.$route.params.pageId, 10)
      const pageIndex = orderPages(this.album.pages, this.album.pageOrders).findIndex(x => x.id === pageId)
      if (pageIndex === -1) {
        this.setCurrentPageIndex(0)
      }
    }
  },
  computed: {
    pages() {
      return orderPages(this.album.pages, this.album.pageOrders)
    },
  },
  components: {
    AlbumThumbnails,
    Avatar,
    FinderView,
    PageTurner,
  },
  methods: {
    albumPages,
    setCurrentPageIndex(index) {
      this.currentPageIndex = index
      this.$router.history.replace(viewPage(this.album.id, this.pages[this.currentPageIndex].id))
    },
    toggleFullScreen() {
      if (fscreen.fullscreenElement !== null) {
        fscreen.exitFullscreen()
      } else {
        fscreen.requestFullscreen(this.$el)
      }
    },
    toggleShowMagnifyingGlass() {
      this.showMagnifyingGlass = !this.showMagnifyingGlass
    },
    toggleFinderView() {
      this.showFinderView = !this.showFinderView
      this.$localStorage.set(localStorageKey, this.showFinderView)
    },
  },
}
</script>

<style lang="stylus" scoped>
</style>
